// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__1l2qe","currentTurn":"Avatar_currentTurn__1X-mp","breathing":"Avatar_breathing__1QOeE","large":"Avatar_large__69R36"};